import { render, staticRenderFns } from "./ValidateClientHandler.vue?vue&type=template&id=11a96b6c&scoped=true"
import script from "./ValidateClientHandler.vue?vue&type=script&lang=js"
export * from "./ValidateClientHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a96b6c",
  null
  
)

export default component.exports